<template>
  <div class="detail_content">
    <div class="detail_label">
      {{titleLabel}}
    </div>
    <div class="corporation_info_label detail_label" v-text='valueLabel'>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String,
    valueLabel: String
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/valueLabelSection.vue